import API from "./API.js";
const signInService = new API(window.origin + `/SignInService/SignInService.svc`);

export async function createTemporaryUser() {
	return signInService.POST(`/CreateTemporaryUser`)
		.then((result) => result.CreateTemporaryUserResult)
		.then(function (userInfo) {
			window.setWindowVariables(userInfo);
		});
}